import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  getVehicles, addVehicle, updateVehicle, deleteVehicle
} from './services/vehicleService';
import VehicleTable from './component/VehicleTable';
import VehicleFormModal from './component/VehicleFormModal';

export default function VehicleManager({ username, setIsAuthenticated }) {
  const [vehicles, setVehicles] = useState([]);
  const [formData, setFormData] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem('isAuthenticated') !== 'true') {
      navigate('/');
      return;
    }
    loadVehicles();
  }, [navigate]);

  const loadVehicles = async () => {
    try {
      setVehicles(await getVehicles());
    } catch {
      alert('Failed to load vehicle data');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const updated = isEditMode
        ? await updateVehicle(formData)
        : await addVehicle(formData);
      setVehicles(updated);
      closeModal();
    } catch {
      alert(`Failed to ${isEditMode ? 'update' : 'save'} vehicle`);
    }
  };

  const handleDelete = async (number) => {
    if (!window.confirm(`Are you sure you want to delete vehicle "${number}"?`)) return;
    try {
      setVehicles(await deleteVehicle(number));
    } catch {
      alert('Failed to delete vehicle');
    }
  };

  const openAddModal = () => {
    setFormData({});
    setIsEditMode(false);
    setShowModal(true);
  };

  const editVehicle = (vehicle) => {
    setFormData(vehicle);
    setIsEditMode(true);
    setShowModal(true);
  };

  const closeModal = () => {
    setFormData({});
    setIsEditMode(false);
    setShowModal(false);
  };

  const handleLogout = () => {
    sessionStorage.clear();
    setIsAuthenticated(false);
    navigate('/');
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Vehicle Details</h2>
        <div>
          <span className="me-3">Welcome, {username}!</span>
          <button className="btn btn-secondary" onClick={handleLogout}>Logout</button>
        </div>
      </div>

      <button className="btn btn-success mb-3" onClick={openAddModal}>Add Vehicle</button>

      {showModal && (
        <VehicleFormModal
          formData={formData}
          setFormData={setFormData}
          isEditMode={isEditMode}
          onClose={closeModal}
          onSubmit={handleSubmit}
        />
      )}

      <VehicleTable
        vehicles={vehicles}
        onEdit={editVehicle}
        onDelete={handleDelete}
      />
    </div>
  );
}
